import emojiFlags from 'emoji-flags';
import { isString, upperCase } from 'lodash';

function getEmojiFlag(code?: string) {
  if (!isString(code)) {
    return '';
  }
  let emoji = null;
  try {
    emoji = emojiFlags.countryCode(upperCase(code));
  } catch (error) {
    emoji = null;
  }
  if (!emoji) {
    return '';
  }
  return emoji.emoji;
}

export default getEmojiFlag;
